export const SEXES_OPTIONS = [
  {
    label: 'Masculino',
    value: 'M',
  },
  {
    label: 'Feminino',
    value: 'F',
  },
  {
    label: 'Neutro',
    value: 'N',
  },
]
